export default {
  translation: {
    common: {
      accept: 'Aceptar',
      alreadyUser: '¿Ya eres usuario?',
      and: 'y',
      backToLogin: 'Volver a la página de inicio de sesión',
      continueWith: 'Continuar con {{provider}}',
      coreNotFound: 'Error al obtener la configuración principal',
      createAccount: 'Crear una cuenta',
      createYourAccount: 'Crea tu cuenta',
      emailOrUsername: 'Correo electrónico o nombre de usuario',
      invalidUsernameOrPassword: 'Nombre de usuario o contraseña inválidos',
      localRegistrationDisabled: 'El registro local de usuarios está deshabilitado por el administrador',
      login: 'Iniciar sesión',
      logInToBoards: 'Iniciar sesión',
      newToBoards: '¿Nuevo en 4ga Boards?',
      noInternetConnection: 'Sin conexión a internet',
      pageNotFound_title: 'Página no encontrada',
      password: 'Contraseña',
      policyNotAccepted: 'Por favor, acepta los Términos de Servicio y la Política de Privacidad',
      privacyPolicy: 'Política de Privacidad',
      register: 'Registrarse',
      registerWithGoogle: 'Registrarse con Google',
      registrationDisabled: 'El registro de usuarios está deshabilitado por el administrador',
      serverConnectionFailed: 'Error de conexión con el servidor',
      ssoRegistrationDisabled: 'El registro SSO de usuarios está deshabilitado por el administrador',
      termsOfService: 'Términos de Servicio',
      togglePasswordVisibility: 'Mostrar u ocultar contraseña',
      unknownError: 'Error desconocido, inténtalo de nuevo más tarde',
    },

    action: {
      logIn: 'Iniciar sesión',
    },
  },
};
